<script>
export default {
  props: {
    tag: { type: String, default: 'div' },
  },
};
</script>

<template>
  <component :is="tag" class="an-overline font-weight-medium">
    <slot></slot>
  </component>
</template>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
@import '@/styles/_mixins';

.an-overline {
  // width: fit-content;
  display: inline-block;
  // border-bottom: 1px solid currentColor;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-decoration-color: currentColor;
  text-transform: uppercase;
  @include font-size(14px);
  line-height: 1.16;
  letter-spacing: to-rem(2px);
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    @include font-size(16px);
  }
}
</style>
